import React, { useState, useEffect, useContext, Fragment } from "react";
import { useNavigate, Link } from "react-router-dom";
import { usePendingUpdates } from "../../lib/usePendingUpdates";
import PendingUpdateCard from "../../pages/PendingUpdateCard";
import useStatutoryDocs from "../../lib/useFetchStatutoryDocs";
import ViewOtherLicenses from "../../Viewdocuploaded/viewotherlicenses/viewotherlicenses";
import ViewOtherDocs from "../../Viewdocuploaded/viewotherdocs/viewotherdocs";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ReactComponent as Markicon } from "../../../Asset/circle.svg";
import { CiFileOn } from "react-icons/ci";
import { AuthContext } from "../../../Context/AuthContext";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { toast, ToastContainer } from "react-toastify";
import "./typeofupdate.css";

const TypeOfUpdate = () => {
  const { data: statutoryDoc, error: staError, isLoading: staLoading } = useStatutoryDocs();
  const { data, error, isLoading } = usePendingUpdates();
  const { profileData } = useContext(AuthContext);
  const navigate = useNavigate();

  const [isAllDocs, setAllDoc] = useState(true);
  const [isAllPendingUpdate, setAllPendingUpdate] = useState(false);
  const [activeSection, setActiveSection] = useState("typeofupdate");
  const [pdfUrl, setPdfUrl] = useState("");
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Check if we're in dashboard mode by looking at the URL path
  const isDashboardMode = window.location.pathname.includes('charterer-dashboard');
  
  // Set the correct navigation paths based on whether we're in the dashboard or not
  const getPath = (path) => {
    return isDashboardMode ? `/charterer-dashboard/${path}` : `/${path}`;
  };

  const activeStyle = {
    border: "1px solid #0963EB",
  };

  const activeSwitchLineStyle = {
    borderBottom: "3px solid #0754c8",
  };

  useEffect(() => {
    if (profileData && !isDashboardMode) {
      const profileStepStatus = profileData.createdProfileStepStatus?.status;
      let navigateTo = "";
      let message = "Redirecting...";
  
      if (profileStepStatus === "1") {
        navigateTo = "/statutorydocs";
        message = "Please complete the statutory documents. Redirecting...";
      } else if (profileStepStatus === "2") {
        navigateTo = "/license";
        message = "Please complete the licenses. Redirecting...";
      } else if (profileStepStatus === "3") {
        navigateTo = "/otherdocs";
        message = "Please complete the other documents. Redirecting...";
      } else if (profileStepStatus === undefined || profileStepStatus === null) {
        navigateTo = "/Customeractivationpage1";
        message = "Please complete the activation process. Redirecting...";
      } else {
        navigate("/typeofupdate")
      }
  
      if (navigateTo) {
        toast.dismiss(); 
        toast.info(message, { autoClose: 3000 });
  
        setTimeout(() => {
          navigate(navigateTo);
        }, 3000);
      }
    }
  }, [profileData, navigate, isDashboardMode]);
  
  const companyData = data?.data || {};
  const statutoryDocuments = statutoryDoc?.data?.statutoryDocuments || {};

  const handleViewPdf = (url) => {
    setIsLoadingPdf(true);
    setPdfUrl(url); 
    setShowModal(true);
  };

  useEffect(() => {
    if (pdfUrl) {
      const timer = setTimeout(() => setIsLoadingPdf(false), 1000); 
      return () => clearTimeout(timer); 
    }
  }, [pdfUrl]);

  const closeModal = () => {
    setShowModal(false); 
    setPdfUrl(""); 
  };

  return (
    <Fragment>
      <ToastContainer/>
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {isLoadingPdf ? (
              <p>Loading document...</p>
            ) : (
              <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
                <Viewer fileUrl={pdfUrl} />
              </Worker>
            )}
          </div>
          <button className="close-btn" onClick={closeModal}>
            Close
          </button>
        </div>
      )}

      <div className="type-of-update">
        <div className="wrap">
        <div className="switch">
          <div
            className="per-info"
            onClick={() => {
              setActiveSection("personalInfo");
              navigate(getPath("updatecustomerprofile"));
            }}
            style={activeSection === "personalInfo" ? activeStyle : {}}
          >
            <h3>Personal Info</h3>
            <p>Manage personal details</p>
          </div>

          <div
            className="document"
            onClick={() => {
              setActiveSection("typeofupdate");
              navigate(getPath("typeofupdate"));
            }}
            style={activeSection === "typeofupdate" ? activeStyle : {}}   
          >
            <h3>Documents</h3>
            <p>Update License and other documents</p>
          </div>

          <div
            className="change-pass"
            onClick={() => {
              setActiveSection("changePass");
              navigate(getPath("updatecustomerpass"));
            }}
            style={activeSection === "changePass" ? activeStyle : {}}
          >
            <h3>Password</h3>
            <p>Change and manage password</p>
          </div>
        </div>

        <div className="content">
          {/* Mobile Navigation Tabs */}
          <div className="mobile-tabs">
            <div
              className={`mobile-tab ${activeSection === "personalInfo" ? "active" : ""}`}
              onClick={() => {
                setActiveSection("personalInfo");
                navigate(getPath("updatecustomerprofile"));
              }}
            >
              <h3>Personal Info</h3>
              <p>Manage personal details</p>
            </div>
            <div
              className={`mobile-tab ${activeSection === "typeofupdate" ? "active" : ""}`}
              onClick={() => {
                setActiveSection("typeofupdate");
                navigate(getPath("typeofupdate"));
              }}
            >
              <h3>Documents</h3>
              <p>Update License and other documents</p>
            </div>
            <div
              className={`mobile-tab ${activeSection === "changePass" ? "active" : ""}`}
              onClick={() => {
                setActiveSection("changePass");
                navigate(getPath("updatecustomerpass"));
              }}
            >
              <h3>Password</h3>
              <p>Change and manage password</p>
            </div>
          </div>
          
          <div className="header">
          </div>
          <div className="switch-line">
            <h3
              onClick={() => {
                setAllDoc(true);
                setAllPendingUpdate(false);
              }}
              style={isAllDocs ? activeSwitchLineStyle : {}}
            >
              {
                profileData?.profileVerifiedAtLeastOnce ? "Approved documents" : " Uploaded documents"
              }
             
            </h3>
            <h3
              onClick={() => {
                setAllDoc(false);
                setAllPendingUpdate(true);
              }}
              style={isAllPendingUpdate ? activeSwitchLineStyle : {}}
            >
              Pending Approvals
            </h3>
            {/* <h3>Approved</h3> */}
          </div>
          <div className="wrapper">
            {isAllDocs && (
              <div className="card">
                <div className="sta">
                  <span>
                    <h3>Statutory Documents</h3>
                    <Link to={isDashboardMode ? "/updatedocs" : "/updatedocs"}>Update</Link>
                  </span>
                  {staLoading ? (
                    <div className="sta-card">
                      {[...Array(5)].map((_, index) => (
                        <div className="cards" key={index}>
                          <div className="in">
                            <Skeleton circle height={40} width={40} />
                            <div className="size">
                              <Skeleton height={20} width={100} />
                              <Skeleton height={16} width={200} />
                            </div>
                          </div>
                          <div className="mark">
                            <Skeleton height={30} width={60} />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : staError ? (
                    <p>Error: {staError.message}</p>
                  ) : (
                    <div className="sta-card">
                      {Object.keys(statutoryDocuments)
                        .filter((key) => key !== "_id")
                        .map((key) => (
                          <div className="cards" key={key}>
                            <div className="in">
                              <CiFileOn className="file" />
                              <div className="size">
                                <h4>{key.toLocaleUpperCase()}</h4>
                                <p>200 KB – 100% Uploaded</p>
                              </div>
                            </div>

                            <div className="mark">
                              <Markicon />
                              <button onClick={() => handleViewPdf(statutoryDocuments[key])}>
                                View
                              </button>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
                <div className="sta">
                  <span>
                    <h3>Licenses</h3>
                    <Link to={isDashboardMode ? "/updatelicense" : "/updatelicense"}>Update</Link>
                  </span>
                  <ViewOtherLicenses />
                </div>
                <div className="sta">
                  <span>
                    <h3>Other Documents</h3>
                    <Link to={isDashboardMode ? "/updateotherdocs" : "/updateotherdocs"}>Update</Link>
                  </span>
                  <ViewOtherDocs />
                </div>
              </div>
            )}
            {isAllPendingUpdate && (
              <div className="pending-card">
                {isLoading ? (
                  <>
                    <Skeleton height={60} width={500} />
                    <Skeleton height={60} width={500} />
                    <Skeleton height={60} width={500} />
                  </>
                ) : error ? (
                  <p>Error: {error.message}</p>
                ) : (
                  <PendingUpdateCard
                    update={companyData}
                    isLoading={isLoading}
                    error={error}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TypeOfUpdate;

